import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, resolveComponent as _resolveComponent, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "mt-0" }
const _hoisted_2 = {
  class: "list-unstyled",
  style: {"padding-left":"2rem"}
}

import { computed } from 'vue';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { BAlert, BButton, BModal } from 'bootstrap-vue-next';
import { useUserStore } from '@/store/user';

// --- User Store ---

export default /*@__PURE__*/_defineComponent({
  __name: 'AnalyticsGuide',
  props: {
    show: { type: Boolean }
  },
  emits: ["update:show"],
  setup(__props: any, { emit: __emit }) {

const userStore = useUserStore();

// --- Component Properties ---

const props = __props;

// --- Component Emits ---
const emit = __emit;

// Bridge prop <-> v-model for the modal
const visible = computed({
  get: () => props.show,
  set: (val: boolean) => emit('update:show', val),
});

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_unref(BModal), {
      modelValue: visible.value,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((visible).value = $event)),
      size: "lg"
    }, {
      title: _withCtx(() => [
        _createVNode(_unref(FontAwesomeIcon), {
          icon: "book",
          class: "me-2"
        }),
        _cache[3] || (_cache[3] = _createTextVNode(" Sampling Human Analytics Cloud - User Guide ", -1))
      ]),
      footer: _withCtx(() => [
        _createVNode(_unref(BButton), {
          variant: "secondary",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (visible.value = false))
        }, {
          default: _withCtx(() => [...(_cache[33] || (_cache[33] = [
            _createTextVNode("Close", -1)
          ]))]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", null, [
          _createVNode(_unref(BAlert), {
            modelValue: _unref(userStore).noOrganizationSelected,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(userStore).noOrganizationSelected) = $event)),
            variant: "warning"
          }, {
            default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
              _createElementVNode("h5", null, "Access Required", -1),
              _createElementVNode("p", null, " You are not associated with any organization. Please contact your account manager to get access to all cloud analytics features first. When you have access, this guide will walk you through the standard workflow to analyze your data. ", -1)
            ]))]),
            _: 1
          }, 8, ["modelValue"]),
          _createElementVNode("h1", _hoisted_1, [
            _createVNode(_unref(FontAwesomeIcon), {
              icon: "dna",
              class: "me-2"
            }),
            _cache[5] || (_cache[5] = _createTextVNode(" DNA/RNA extraction ", -1))
          ]),
          _cache[31] || (_cache[31] = _createElementVNode("p", null, " Begin in the lab by extracting DNA/RNA with a Sampling Human kit. Record the kit code/ID and keep it linked to your samples — you'll provide this during data upload. Libraries are then prepared and sent for sequencing. ", -1)),
          _createElementVNode("h1", null, [
            _createVNode(_unref(FontAwesomeIcon), {
              icon: "upload",
              class: "me-2"
            }),
            _cache[6] || (_cache[6] = _createTextVNode(" Import data ", -1))
          ]),
          _createElementVNode("p", null, [
            _cache[8] || (_cache[8] = _createTextVNode(" When sequencing is complete, bring the data into the Sampling Human Analytics Cloud via ", -1)),
            _createVNode(_component_router_link, { to: { name: 'UploadManager' } }, {
              default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                _createTextVNode("Upload Manager", -1)
              ]))]),
              _: 1
            }),
            _cache[9] || (_cache[9] = _createTextVNode(": ", -1))
          ]),
          _createElementVNode("ul", _hoisted_2, [
            _createElementVNode("li", null, [
              _createVNode(_unref(FontAwesomeIcon), {
                icon: "upload",
                class: "me-2"
              }),
              _cache[10] || (_cache[10] = _createTextVNode(" Direct file upload ", -1))
            ]),
            _createElementVNode("li", null, [
              _createVNode(_unref(FontAwesomeIcon), {
                icon: "server",
                class: "me-2"
              }),
              _cache[11] || (_cache[11] = _createTextVNode(" FTP transfer from your sequencing provider ", -1))
            ]),
            _createElementVNode("li", null, [
              _createVNode(_unref(FontAwesomeIcon), {
                icon: "info-circle",
                class: "me-2"
              }),
              _cache[12] || (_cache[12] = _createTextVNode(" Import from Illumina BaseSpace Sequence Hub (BSSH) ", -1))
            ])
          ]),
          _cache[32] || (_cache[32] = _createElementVNode("p", null, " During upload, you'll be prompted for the kit code used for extraction. ", -1)),
          _createElementVNode("h1", null, [
            _createVNode(_unref(FontAwesomeIcon), {
              icon: "flask",
              class: "me-2"
            }),
            _cache[13] || (_cache[13] = _createTextVNode(" Sample annotation ", -1))
          ]),
          _createElementVNode("p", null, [
            _cache[15] || (_cache[15] = _createTextVNode(" After upload, annotate samples with metadata in ", -1)),
            _createVNode(_component_router_link, { to: { name: 'DataManager' } }, {
              default: _withCtx(() => [...(_cache[14] || (_cache[14] = [
                _createTextVNode("Data Manager", -1)
              ]))]),
              _: 1
            }),
            _cache[16] || (_cache[16] = _createTextVNode(", or enable Auto-annotation during upload to fill fields automatically. You can edit annotations later. Samples imported from BSSH are pre- annotated from BSSH metadata where available. ", -1))
          ]),
          _createElementVNode("h1", null, [
            _createVNode(_unref(FontAwesomeIcon), {
              icon: "list",
              class: "me-2"
            }),
            _cache[17] || (_cache[17] = _createTextVNode(" Projects ", -1))
          ]),
          _createElementVNode("p", null, [
            _cache[20] || (_cache[20] = _createTextVNode(" Processing happens inside projects, not in Data Manager. Create a project in ", -1)),
            _createVNode(_component_router_link, { to: { name: 'Projects' } }, {
              default: _withCtx(() => [...(_cache[18] || (_cache[18] = [
                _createTextVNode("Project Manager", -1)
              ]))]),
              _: 1
            }),
            _cache[21] || (_cache[21] = _createTextVNode(", then associate one or more samples (from one or multiple collections). If you enabled it during upload, projects and associations can be created automatically. You can list and manage projects from ", -1)),
            _createVNode(_component_router_link, { to: { name: 'Projects' } }, {
              default: _withCtx(() => [...(_cache[19] || (_cache[19] = [
                _createTextVNode("Project Manager", -1)
              ]))]),
              _: 1
            }),
            _cache[22] || (_cache[22] = _createTextVNode(". ", -1))
          ]),
          _createElementVNode("h1", null, [
            _createVNode(_unref(FontAwesomeIcon), {
              icon: "wand-magic-sparkles",
              class: "me-2"
            }),
            _cache[23] || (_cache[23] = _createTextVNode(" Sample reconstruction ", -1))
          ]),
          _createElementVNode("p", null, [
            _cache[25] || (_cache[25] = _createTextVNode(" Open a project and start a Sample Reconstruction task from the ", -1)),
            _createVNode(_component_router_link, { to: { name: 'Projects' } }, {
              default: _withCtx(() => [...(_cache[24] || (_cache[24] = [
                _createTextVNode("Project Detail", -1)
              ]))]),
              _: 1
            }),
            _cache[26] || (_cache[26] = _createTextVNode(" view. Confirm the correct kit code—this is essential for accurate analysis. Runtime depends on data size and complexity. If desired, enable email notifications in your profile to be alerted when the task finishes. ", -1))
          ]),
          _createElementVNode("h1", null, [
            _createVNode(_unref(FontAwesomeIcon), {
              icon: "line-chart",
              class: "me-2"
            }),
            _cache[27] || (_cache[27] = _createTextVNode(" Review results ", -1))
          ]),
          _createElementVNode("p", null, [
            _cache[29] || (_cache[29] = _createTextVNode(" When reconstruction completes, view outputs in the ", -1)),
            _createVNode(_component_router_link, { to: { name: 'Projects' } }, {
              default: _withCtx(() => [...(_cache[28] || (_cache[28] = [
                _createTextVNode("Project Detail", -1)
              ]))]),
              _: 1
            }),
            _cache[30] || (_cache[30] = _createTextVNode(" view. Browse files, inspect progress and metrics, and download results for further analysis. ", -1))
          ])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})